import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateFormatText } from '../../../helpers/array.helpers';
import { DialogButton } from '../../../models/enums/dialogbutton.enum';
import { MessageBoxButtons } from '../../../models/enums/messageboxbuttons.enum';
import { MessageBoxIcon } from '../../../models/enums/messageboxicon.enum';
import { MailSettingsService } from '../../../services/mailsettings.service';
import { BaseDialog } from '../../dialogs/basedialog/base.dialog';
import { MessageBoxHelper } from '../../dialogs/messagebox/messagebox.dialog';
import { CommonEditorControl } from '../editorcontrol/common.editor.control';

@Component({
    selector: 'send-mail-settings-control',
    templateUrl: './send.mail.settings.control.html',
    styles: ['.tagList { width: 200px; border: 1px solid lightgray; padding: 0px 5px; }']
})
export class SendMailSettingsControl implements OnInit {
    MailSettings: any[] = [];

    SettingsValue: any = {};
    @Input()
    get Settings() {
        return this.SettingsValue;
    }
    set Settings(val) {
        if (val) {
            this.SettingsValue = val;
        } else {
            this.SettingsValue = {};
        }
        this.SettingsChange.emit(this.SettingsValue);
    }
    @Output() SettingsChange = new EventEmitter<any>();

    TagListValue = [
        { Caption: '@@Link', Tag: '$$link$$' },
        { Caption: '@@Vorname', Tag: '$$firstname$$' },
        { Caption: '@@Nachname', Tag: '$$lastname$$' }
    ];
    @Input()
    get TagList() {
        return this.TagListValue;
    }
    set TagList(val) {
        this.TagListValue = val;
    }

    @ViewChild('bodyControl') bodyControl: CommonEditorControl;

    constructor(private service: MailSettingsService) {
    }

    ngOnInit(): void {
        this.service.GetMailSettings().subscribe(result => {
            if (result) {
                this.MailSettings = result;
            }
        });
    }

    onDoubleClick(tag: string) {
        if (this.bodyControl) {
            this.bodyControl.replaceText(tag);
        }
    }

    //#region Dialog
    static ShowDialog(settings, handler) {
        BaseDialog.ShowDialog({
            ContentType: SendMailSettingsControl,
            InitArgs: settings,
            Title: '@@Mail Settings',
            Handler: (result) => {
                if (result) {
                    return handler(result);
                }
                return true;
            }
        });
    }

    Initialize(args) {
        if (args) {
            this.SettingsValue = JSON.parse(JSON.stringify(args));
        }
    }

    GetDialogResult() {
        return this.SettingsValue;
    }

    OnDialogButtonClickAction(button: DialogButton) {
        if (button === DialogButton.Ok) {
            if (this.SettingsValue && this.SettingsValue.Body && this.SettingsValue.Body.indexOf('$$link$$') < 0) {
                MessageBoxHelper.ShowDialog(new TranslateFormatText('@@ForgotPWMissingLink'),
                    new TranslateFormatText('@@Information'), MessageBoxButtons.Ok, MessageBoxIcon.Information);
                return false;
            }
        }
        return true;
    }
    //#endregion
}